// Общие логистические константы портала. Единый источник, чтобы копии не расходились по значению.

/**
 * Грузоподъёмность одной машины (ТС), тонн. Согласовано с бизнесом: неделимая загрузка 30 т,
 * заявка на продажу кратна 30. Используется для перевода суточной мощности «в машинах» (rate.type='TS')
 * в тонны: X авто/сут → X × TONS_PER_VEHICLE т/сут.
 */
export const TONS_PER_VEHICLE = 30;
